import React, { FunctionComponent } from 'react';
import { GridPageLayout } from '@lux/grid';
import { useTranslate, TranslateScope } from '@pegasus/translation';
import { useConfig } from 'src/client/hoc/config';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { getMenuItems, MenuItem } from 'src/shared/cms';
import { isWebView } from 'src/client/helpers';
import { PageWrapper, NestedList, Content, ColumnWrapper, ContentWrapper, Header } from './styles';
import NestedListItem from './nested-list-item';
import { CallUsItem, EmailUsItem, HelpPageItem } from './contact-us';
import { handleClick } from './helper';
import { getRenderOptions } from './rich-text-options';
import { StaticPageDefinition } from './hooks/use-static-page';

const isClient = () => typeof window !== 'undefined';

const getPageNameClass = () =>
    isClient() && window.location.href.includes('sizechart') ? 'size-chart-paragraph' : '';

export const MenuLevel: FunctionComponent<{ items: MenuItem[] }> = ({ items = [] }) => {
    const translate = useTranslate();

    return (
        <>
            {items.map(({ title, url, children = [], showDivider }) => (
                <NestedListItem
                    key={url}
                    url={url}
                    showDivider={showDivider}
                    title={translate(`sideMenu.${title}`)}
                >
                    {children.length && <MenuLevel items={children} />}
                </NestedListItem>
            ))}
        </>
    );
};

export const StaticPage: FunctionComponent<StaticPageDefinition> = ({
    html,
    header,
    type,
    richText,
}) => {
    const config = useConfig();
    const items = getMenuItems(config);
    const isWebview = isWebView();
    const theme = {
        paddingZero: isWebview,
    };

    const pageNameClass = getPageNameClass();

    return (
        <GridPageLayout>
            <PageWrapper theme={theme}>
                {!isWebview && (
                    <ColumnWrapper>
                        <TranslateScope>
                            <NestedList disableBorders>
                                <MenuLevel items={items} />
                            </NestedList>
                            {items.length > 0 && !config.enable.prelaunch && (
                                <>
                                    <CallUsItem />
                                    <HelpPageItem />
                                    <EmailUsItem />
                                </>
                            )}
                        </TranslateScope>
                    </ColumnWrapper>
                )}
                <ContentWrapper>
                    {type === 'richText' ? (
                        <>
                            {!isWebview && <Header>{header}</Header>}
                            <Content>
                                {documentToReactComponents(
                                    richText,
                                    getRenderOptions(pageNameClass),
                                )}
                            </Content>
                        </>
                    ) : (
                        <>
                            {!isWebview && <Header dangerouslySetInnerHTML={{ __html: header }} />}
                            <Content
                                onClick={handleClick}
                                dangerouslySetInnerHTML={{ __html: html }}
                            />
                        </>
                    )}
                </ContentWrapper>
            </PageWrapper>
        </GridPageLayout>
    );
};

export default StaticPage;
